// extracted by mini-css-extract-plugin
module.exports = {"profilePic":"Header_profilePic__19yjQ","navTabs":"Header_navTabs__2uT_s","navBar":"Header_navBar__-O5bs"};